module.exports = __webpack_public_path__ + "static/media/terms.7c5c2525.md";


//////////////////
// WEBPACK FOOTER
// ./src/markdown/terms.md
// module id = 1377
// module chunks = 0